// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.FilterList.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import { formattedDateTime } from 'share/utils/Izenda.DateTimeUtils';

const FilterList = (props) => {
    const { removeNLQFilterItem, itemData } = props;
    const { alias, value, operatorName,dataType } = itemData;

    let formattedValue = value;
    const fieldDataType = dataType.toLowerCase();
    if (fieldDataType == 'datetime' || fieldDataType == 'date') {
        formattedValue = formattedDateTime(value);
        if (operatorName.toLowerCase() == 'between') {
            const dateValues = value.split(';#');
            formattedValue = formattedDateTime(dateValues[0]) + ' and ' + formattedDateTime(dateValues[1]);
        } 
    }

    return (
        <span>
            <i className="icon icon-filter"></i>
            {alias} {operatorName} {formattedValue.replace(';#', ' and ')}
            <i className="icon icon-cancel" onClick={removeNLQFilterItem.bind(this, itemData)}></i>
        </span>
    );
};

export default FilterList;



// WEBPACK FOOTER //
// ./ui/share/components/controls/Filter/Izenda.FilterList.jsx